'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  loading: _propTypes2.default.bool,
  error: _propTypes2.default.bool,
  taxonomy: _propTypes2.default.shape({
    parents: _propTypes2.default.array,
    activeNode: _propTypes2.default.shape(),
    children: _propTypes2.default.array
  })
});


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/taxonomyStatePropType.js
// module id = 634
// module chunks = 11